/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Sources_CountInputs */

const en_directory_detail_sources_count = /** @type {(inputs: Directory_Detail_Sources_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} source groups`)
};

const zh_directory_detail_sources_count = /** @type {(inputs: Directory_Detail_Sources_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个来源组`)
};

/**
* | output |
* | --- |
* | "{count} source groups" |
*
* @param {Directory_Detail_Sources_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_sources_count = /** @type {((inputs: Directory_Detail_Sources_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Sources_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_sources_count(inputs)
	return zh_directory_detail_sources_count(inputs)
});
export { directory_detail_sources_count as "directory.detail.sources_count" }